/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Structs
 */

module.exports = {

    List: require('./List'),
    Map: require('./Map'),
    ProcessQueue: require('./ProcessQueue'),
    RTree: require('./RTree'),
    Set: require('./Set')

};



//////////////////
// WEBPACK FOOTER
// ./structs/index.js
// module id = 919
// module chunks = 0